// 장바구니 개수 저장
import { defineStore } from "pinia";
import * as cmUtil from "@/utils/cmUtil";

export const useBasketCountStore = defineStore({
  id: "basketCount",
  state: () => ({
    basketCount: 0,
  }),
  actions: {
    setBasketCount(count) {
      this.basketCount = count;
      cmUtil.setLocalStorage("gv.basketCount", count);
    },
  },
});
